import { Control, FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormCheckbox, Link, Stack, Typography } from '../../base';
import { RoutePaths } from '../../routes/RoutePaths';
import { LANGUAGES } from '../../common';

interface TermsAndConditionsCheckboxProps<T extends FieldValues> {
    control: Control<T>;
    name: Path<T>;
    label?: string;
}

const TermsAndConditionsCheckbox = <T extends FieldValues>({
    control,
    name,
    label,
}: TermsAndConditionsCheckboxProps<T>) => {
    const { t, i18n } = useTranslation();

    const defaultLabel = t('termsAndConditions.iAgreeToThe');

    // Get current language and build query parameter
    const currentLanguage = i18n.language.toLowerCase();
    const languageParam =
        currentLanguage !== LANGUAGES.EN.toLowerCase()
            ? `?lan=${currentLanguage}`
            : '';

    const handleOpenTermsAndConditions = () => {
        window.open(
            `${RoutePaths.termsAndServices}${languageParam}`,
            '_blank',
            'noopener,noreferrer'
        );
    };

    const handleOpenPrivacyPolicy = () => {
        window.open(
            `${RoutePaths.privacyPolicy}${languageParam}`,
            '_blank',
            'noopener,noreferrer'
        );
    };

    return (
        <FormCheckbox
            name={name}
            control={control}
            label={
                <Stack direction="row" spacing={0.5} alignItems="center">
                    <Typography variant="body2">
                        {label || defaultLabel}
                    </Typography>
                    <Link
                        onClick={handleOpenTermsAndConditions}
                        sx={{ cursor: 'pointer', lineHeight: 'initial' }}
                    >
                        {t('termsAndConditions.termsAndConditions')}
                    </Link>
                    <Typography variant="body2">
                        {t('termsAndConditions.and')}
                    </Typography>
                    <Link
                        onClick={handleOpenPrivacyPolicy}
                        sx={{ cursor: 'pointer', lineHeight: 'initial' }}
                    >
                        {t('termsAndConditions.privacyPolicy')}
                    </Link>
                </Stack>
            }
        />
    );
};

export default TermsAndConditionsCheckbox;
